import { IMG } from "@/data/catalog";

export const HIGHLIGHTS = [
  ["Boosts Natural Collagen", "For firmer, smoother skin"],
  ["Reduces Fine Lines & Wrinkles", "Smooths visible signs of ageing"],
  ["Brightens & Evens Skin Tone", "Reveal a radiant complexion"],
  ["Restores Your Natural Glow", "Healthy looking, luminous skin"],
  ["Professional Results at Home", "Just 10 minutes daily"],
];

export const BUNDLE_OPTIONS = [
  { sku: "single", label: "1 Mask", tag: "Try it", per: "device", popular: false },
  { sku: "ritual", label: "Complete Ritual", tag: "Best Value", per: "mask + serum + case", popular: true },
  { sku: "duo", label: "2 Masks", tag: "Share the glow", per: "$229 each", popular: false },
];

export const MODES = [
  { name: "Red", nm: "630 nm", swatch: "#E0564B", for: "Collagen & firmness", desc: "The anti-aging workhorse. Stimulates fibroblasts deep in the dermis to rebuild collagen and elastin, softening fine lines and restoring bounce.", benefits: ["Softens fine lines & wrinkles", "Boosts collagen & elastin", "Restores firmness & bounce"], study: { ref: "Wunsch & Matuschka, 2014 — Photomedicine & Laser Surgery", url: "https://pubmed.ncbi.nlm.nih.gov/24286286/" } },
  { name: "Blue", nm: "415 nm", swatch: "#3E6CA8", for: "Clarity & breakouts", desc: "Targets P. acnes bacteria inside the sebaceous glands while calming inflammation, clearing active breakouts and preventing new ones.", benefits: ["Clears active breakouts", "Kills acne-causing bacteria", "Calms redness & inflammation"], study: { ref: "Papageorgiou et al., 2000 — British Journal of Dermatology", url: "https://pubmed.ncbi.nlm.nih.gov/10809858/" } },
  { name: "Near-Infrared", nm: "850 nm", swatch: "#B5362F", for: "Deep repair", desc: "Penetrates the deepest of all wavelengths to accelerate cellular repair, boost circulation and strengthen the skin barrier from within.", benefits: ["Accelerates cellular repair", "Strengthens the skin barrier", "Boosts circulation & healing"], study: { ref: "Wunsch & Matuschka, 2014 — Photomedicine & Laser Surgery", url: "https://pubmed.ncbi.nlm.nih.gov/24286286/" } },
  { name: "Pink", nm: "Red + Blue", swatch: "#F6A5C0", for: "Glow & calm", desc: "A balanced blend that clarifies and brightens in one session, our community's favourite for an all-over radiant finish.", benefits: ["Brightens & evens skin tone", "Clarifies and soothes at once", "Leaves an all-over radiant glow"], study: { ref: "Papageorgiou et al., 2000 — British Journal of Dermatology", url: "https://pubmed.ncbi.nlm.nih.gov/10809858/" } },
];

export const INBOX = [
  ["Leopard Luxe™ LED Light Therapy Mask", "114 medical-grade LEDs in flexible silicone", IMG.product],
  ["Smart Remote Control", "Switch modes & timing with one touch", IMG.deviceDetail],
  ["Adjustable Head Straps", "Secure, comfortable, indentation-free fit", IMG.flexible],
  ["Silk Carry Bag + Cable", "USB-C charging cable & travel-ready silk pouch", IMG.unboxing],
];

export const HOWTO = [
  ["01", "Cleanse", "Wash your face and pat dry. Use on clean, bare skin so the light can work its magic.", IMG.stepCleanse],
  ["02", "Mask up", "Adjust the straps for a comfy fit, press power and pick your light mode, then relax for 10 minutes. Use 3 to 5 times a week.", IMG.glowFront],
  ["03", "Glow on", "Remove the mask, apply your favourite serum and moisturiser, then wipe the mask clean and store.", IMG.stepGlow],
];

export const CLINICAL = [
  [94, "%", "saw brighter, more even skin tone within 4 weeks"],
  [89, "%", "reported softer fine lines & smoother texture"],
  [97, "%", "said it's the most comfortable LED mask they've worn"],
  [10, "min", "the entire daily ritual, that's it"],
];

export const RATING_DIST = [
  [5, 87],
  [4, 9],
  [3, 3],
  [2, 1],
  [1, 0],
];

export const EDITORIAL = [
  {
    overline: "World-First Design",
    title: "Where beauty meets science.",
    body: "Most masks are rigid, clinical and frankly, a chore. The Leopard Luxe™ is moulded from soft, flexible medical-grade silicone that contours to every curve of your face, for deeper, more even light absorption and a fit that never leaves a mark. It's the rare device you'll actually look forward to wearing.",
    img: IMG.flexible,
    reverse: false,
  },
  {
    overline: "Clinically Powerful",
    title: "Salon-grade intensity, engineered for home.",
    body: "At 53 mW/cm² irradiance with 114 high-performance LEDs, the Leopard Luxe™ delivers a clinically effective dose of light that actually penetrates the skin, where real change happens. Four wavelengths across six modes target everything from breakouts to fine lines. This is professional technology, beautifully disguised.",
    img: IMG.glowFront,
    reverse: true,
  },
];
